import { render, staticRenderFns } from "./OSendEmailButton.vue?vue&type=template&id=35561905&scoped=true&"
import script from "./OSendEmailButton.vue?vue&type=script&lang=js&"
export * from "./OSendEmailButton.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35561905",
  null
  
)

export default component.exports